import DocumentService from '@/services/Documents'
import { saveAs } from 'file-saver'

export interface FilePreview {
  url: string;
  isPDF: boolean;
}

// Los PDF se identifican por su firma y no solo por el content-type, porque el
// backend puede servirlos como application/octet-stream.
function hasPdfSignature (data: any): boolean {
  if (!(data instanceof ArrayBuffer) || data.byteLength < 5) return false
  const head = new Uint8Array(data, 0, Math.min(1024, data.byteLength))
  let text = ''
  for (let i = 0; i < head.length; i++) text += String.fromCharCode(head[i])
  return text.includes('%PDF-')
}

/**
 * Construye la URL de previsualizacion de una respuesta binaria.
 *
 * Se usa un object URL y no un data URL en base64 porque Chromium descarta las
 * URLs de mas de 2 MB (`url::kMaxURLChars`) al pasarlas al proceso del visor de
 * PDF, dejando el iframe en blanco sin ningun error. Como base64 crece 4/3,
 * cualquier archivo de mas de ~1.5 MB (por ejemplo varias CFI escaneadas) caia
 * en ese limite y no se lograba visualizar.
 */
export function buildFilePreview (response: any): FilePreview {
  const contentType = (response.headers && response.headers['content-type']) || ''
  const isPDF = contentType.includes('application/pdf') || hasPdfSignature(response.data)
  const type = isPDF ? 'application/pdf' : (contentType.split(';')[0] || 'application/octet-stream')
  return { url: URL.createObjectURL(new Blob([response.data], { type })), isPDF }
}

/** Libera un object URL creado por buildFilePreview para no filtrar memoria. */
export function revokeFilePreview (url: any) {
  if (typeof url === 'string' && url.indexOf('blob:') === 0) URL.revokeObjectURL(url)
}

export default class Documents {
  static async download (document: any) {
    const [error, response] = await DocumentService.getDocument({
      entity_type: document.owner_category,
      identity: document.company_id,
      document_type: document.type
    })
    if (error) return [error]
    const fileType = response.headers['content-type'].split('/')[1]
    const blob = new Blob([response.data])
    saveAs(blob, `${document.type}.${fileType}`)
    return [null]
  }
}
